export enum StoreKey {
	APP = 'app',
	CREATOR = 'creator',
	TUTORIAL = 'tutorial',
}
